import "./product-selector-card.scss";
import { html, LitElement, nothing, PropertyValues } from "lit";
import ComponentBase from "./component-base";
import { property } from "lit/decorators.js";
import { ProductDto } from "../model/dtos";
import productPlaceholderImage from "../assets/images/product_placeholder.png";
import { FormatPrice } from "../assets/js/libs/utils";
import { selectConfigShowPrices } from "../webapps/shop/redux/actions";

class ProductSelectorCard extends ComponentBase {
  static get tagName() {
    return "product-selector-card";
  }

  @property()
  product: ProductDto;
  @property()
  isSelected: boolean;

  protected render(): unknown {
    return html`
      <div
        class="${this.isSelected
        ? "selected shadow"
        : "shadow-sm"} product-selector-card"
      >
        <img src="${this.product.thumbnail}" />
        <div class="product-selector-card__content">
          <div class="product-selector-card__content__name">
            ${this.product.name}
          </div>
          ${selectConfigShowPrices() === true ? html`<div class="card-text">+ ${FormatPrice().format(this.product.price)}</div>` : nothing}
        </div>
      </div>
    `;
  }

  protected firstUpdated(_changedProperties: PropertyValues): void {
    this.addEventListener("click", () => {
      const evt = new CustomEvent("selected", {
        detail: {
          ...this.product,
        },
      });
      this.dispatchEvent(evt);
    });
  }
}
ProductSelectorCard.Register();

export default ProductSelectorCard;
